import type { ItemSectionMenu } from "@front/components/Container/Www/_Menu/types";
import type { ItemSectionFooter } from "@front/components/Container/Www/_Footer/types";

import { usePathCommon } from "../router/routes/common";
import { usePathWww } from "../router/routes/www";

export function useItemsNav() {
    const pathTerms = usePathCommon("COMMON_SUPPORT_TERMS");
    const pathPrivacy = usePathCommon("COMMON_SUPPORT_PRIVACY");
    const pathSignUp = usePathCommon("COMMON_SIGN_UP");
    const pathAbout = usePathWww("WWW_ABOUT");
    const pathHelp = usePathWww("WWW_SUPPORT");
    const urlBlog = usePathWww("WWW_BLOG");

    const itemsMenu: ItemSectionMenu[] = [
        { text: "try-it-cta", icon: "menu-login", href: pathSignUp },
        { text: "options-about", icon: "menu-about", href: pathAbout },
        { text: "options-help", icon: "menu-help", href: pathHelp },
        { text: "options-blog", icon: "menu-login", href: urlBlog },
    ];

    const itemsFooter: ItemSectionFooter[] = [
        { text: "options-terms", path: pathTerms },
        { text: "options-privacy", path: pathPrivacy },
    ];

    return {
        menu: itemsMenu,
        footer: itemsFooter,
    };
}
